import { Plus, Typography } from '@weareopenr/component-library';
import styles from './NewItemCard.module.scss';

interface NewItemCardProps {
  text: string;
  onClick: () => void;
}

const NewItemCard = ({ text, onClick }: NewItemCardProps) => (
  <button className={styles['card']} onClick={onClick} type="button">
    <div className={styles['content']}>
      <Plus size="medium" />
      <Typography className={styles['primary']}>{text}</Typography>
    </div>
  </button>
);

export default NewItemCard;
